<div class="sp-width__full sp-height__full sp-border-radius__s sp-background__accent-contrast sp-padding__x2">
  <div class="sp-row__space">
    <div class="sp-row__align">
      <h3 class="sp-color__primary sp-padding">{{ 'GENERAL.COMPANY_LABEL' | translate }}</h3>
    </div>
    <div>
      <button
        mat-icon-button
        class="sp-icon__button sp-icon__button-dark sp-margin__left"
        [matTooltip]="'GENERAL.SEE_DETAILS_CTA' | translate"
        (click)="onDetailsClick(order?.company_id || '-')">
        <mat-icon class="material-symbols-outlined"> visibility </mat-icon>
      </button>
    </div>
  </div>
  <div
    class="sp-width__full sp-margin__top-x2 sp-order-details-general-company__grid sp-grid__column-gap-x2 sp-grid__row-gap">
    <app-shared-info-copy
      [label]="'ORDERS.COMPANY_ID_COLUMN_LABEL'"
      [content]="order?.company_id || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
    <app-shared-info-copy
      [label]="'ORDERS.STORE_ID_COLUMN_LABEL'"
      [content]="order?.store_id || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
    <app-shared-info
      [label]="'GENERAL.STORE_LABEL'"
      [content_class]="'sp-text__ellipsized'"
      [is_update_enabled]="false">
      <div class="sp-row__align">
        <app-shared-store-logo
          size="xs"
          [current_store_logo]="order?.store_logo"></app-shared-store-logo>
        <span class="sp-text__ellipsized sp-margin__left">
          {{ order?.store_name || '-' }}
        </span>
      </div>
    </app-shared-info>
    <app-shared-info-copy
      [label]="'GENERAL.SELLER_ID_LABEL'"
      [content]="order?.seller_id || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
    <app-shared-info
      [label]="'GENERAL.SELLER_NAME_LABEL'"
      [content]="getSellerFullName()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
  </div>
  <div class="sp-margin__top-x2">
    <app-shared-info
      [label]="'GENERAL.SELLER_PHONE_LABEL'"
      [content]="getFormattedPhone()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
  </div>
  <div class="sp-margin__top-x2">
    <app-shared-info
      [label]="'GENERAL.SELLER_EMAIL_LABEL'"
      [content]="order?.seller_email || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
  </div>
</div>
